import { Base } from "./index";


export interface SyncCommandLike extends Base
{
    action: string;
    data: string;
}

export default class SyncCommand implements SyncCommandLike
{
    action: string;
    data: string;
    created_at?: Date;
    modified_at?: Date;
    id?: number;

    public static ACTION_REMOVE_INSTANCE = 'remove_instance';
    public static ACTION_FULL_RESET = 'full_reset';
    public static ACTION_UPDATE_CONSTANCE = 'update_constance';
    public static ACTION_APP_UPDATE = 'app_update';
}

export interface SyncCommandData
{
    name: string;
    key: string;
}